module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('requestToPay.new_req_to_pay'),
      "icon": "icon-sent",
      "returnUrl": "/home/RTP"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [(_vm.rtpType === 'unit') ? _c('form-accordion', {
    attrs: {
      "title": _vm.$t('attachments.doc')
    }
  }, [_c('b-row', [_c('b-col', [(_vm.typeFile === '1' && _vm.attachments.length > 0) ? _c('div', _vm._l((_vm.attachments), function(attachment, id) {
    return _c('b-row', {
      key: id
    }, [_c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "4"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('label', {
      attrs: {
        "id": "application-file-input"
      },
      model: {
        value: (attachment.AttachmentName),
        callback: function($$v) {
          _vm.$set(attachment, "AttachmentName", $$v)
        },
        expression: "attachment.AttachmentName"
      }
    }, [_vm._v("\n                    " + _vm._s(attachment.AttachmentName) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('i', {
      staticClass: "icon fa fa-download mx-1",
      on: {
        "click": function($event) {
          return _vm.view(id)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon fa fa-search mx-1",
      on: {
        "click": function($event) {
          return _vm.openDoc(id)
        }
      }
    })])])]), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "2"
      }
    }, [_c('f7-button', {
      staticClass: "generalBottomButton",
      attrs: {
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.clearInvoice(id)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('creation_forms.clear_label')) + "\n                ")])], 1), _vm._v(" "), _c('b-col', {
      staticClass: "form-group"
    }, [(attachment.AttachmentName !== '') ? _c('form-write-group-label-input', {
      attrs: {
        "placeholderValue": _vm.$t('common.rfrnc')
      },
      model: {
        value: (attachment.AttachmentReference),
        callback: function($$v) {
          _vm.$set(attachment, "AttachmentReference", $$v)
        },
        expression: "attachment.AttachmentReference"
      }
    }) : _vm._e()], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.typeFile === '1') ? _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "xl": "4"
    }
  }, [_c('f7-button', {
    staticClass: "generalBottomButton",
    attrs: {
      "round": "",
      "disabled": !_vm.canSendAttachment
    },
    on: {
      "click": function($event) {
        return _vm.openImportAttachmentInvoice(_vm.typeFile)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fileIsFacturX ? 'Importer une Factur-X' : _vm.$t('attachments.import_doc')) + "\n              ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "xl": "4"
    }
  }, [_c('f7-button', {
    staticClass: "generalBottomButton",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.showDevisForm
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('attachments.generate_invoiceX')) + "\n              ")])], 1), _vm._v(" "), (_vm.isSmartphoneOS) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "xl": "4"
    }
  }, [_c('f7-button', {
    staticClass: "generalBottomButton",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.scanDocument($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('creation_forms.tke_doct_pctr')))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [(_vm.typeFile === "2") ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachmentId),
      expression: "attachmentId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel2",
      "readonly": "",
      "disabled": !_vm.canSendAttachment
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.attachmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.cloudFileSel()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "disabled": ""
    }
  }, [_vm._v("\n                  " + _vm._s(this.hasCloudAttachments ? _vm.$t('creation_forms.slct_a_fl') : _vm.$t('attachments.no_document')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.cloudDocsPicker), function(cloudDoc) {
    return _c('option', {
      key: cloudDoc.id,
      domProps: {
        "value": cloudDoc.id
      }
    }, [_vm._v("\n                  " + _vm._s(cloudDoc.name) + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('input', {
    key: _vm.refreshImport,
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file",
      "disabled": !_vm.canSendAttachment
    },
    on: {
      "change": function($event) {
        return _vm.executeOCR($event, 'INVOICE')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text",
      "disabled": _vm.canSendAttachment
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text",
      "id": "recommendation-list-input",
      "disabled": _vm.canSendAttachment
    }
  })])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.rtpType === 'unit') ? _c('hr') : _vm._e(), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "id": "payment-details",
      "title": _vm.$t('common.formsSubTitle.rqst_to_pay_dtls')
    }
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6",
      "xl": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.$t('common.rsn'),
      "placeholderValue": _vm.$t('common.rsn')
    },
    model: {
      value: (_vm.remittanceInformation),
      callback: function($$v) {
        _vm.remittanceInformation = $$v
      },
      expression: "remittanceInformation"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6",
      "xl": "4"
    }
  }, [_c('select-bank-account', {
    attrs: {
      "labelClass": ''
    },
    model: {
      value: (_vm.creditorBank),
      callback: function($$v) {
        _vm.creditorBank = $$v
      },
      expression: "creditorBank"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6",
      "xl": "2"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "date",
      "disablePastDates": "",
      "inputLabel": _vm.$t('common.execution_date_label'),
      "placeholderValue": _vm.$t('common.slct_date')
    },
    model: {
      value: (_vm.executionDate),
      callback: function($$v) {
        _vm.executionDate = $$v
      },
      expression: "executionDate"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "4",
      "offset-sm": "8",
      "xl": "3",
      "offset-xl": "9"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0,
      "disabled": _vm.readonly
    },
    on: {
      "change": _vm.changeInstPmt
    },
    model: {
      value: (_vm.instantPayment),
      callback: function($$v) {
        _vm.instantPayment = $$v
      },
      expression: "instantPayment"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('creation_forms.isSCTInst')) + "\n          ")])], 1)], 1), _vm._v(" "), (_vm.attachments.length === 0) ? _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "cols": "6",
      "md": "3",
      "align-self": "center"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "name": "rtpType-radio",
      "value": "unit"
    },
    model: {
      value: (_vm.rtpType),
      callback: function($$v) {
        _vm.rtpType = $$v
      },
      expression: "rtpType"
    }
  }, [_vm._v("\n            " + _vm._s('RTP unitaire') + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "cols": "6",
      "md": "9",
      "xl": "3",
      "align-self": "center"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "name": "rtpType-radio",
      "value": "group"
    },
    model: {
      value: (_vm.rtpType),
      callback: function($$v) {
        _vm.rtpType = $$v
      },
      expression: "rtpType"
    }
  }, [_vm._v("\n            " + _vm._s('RTP groupé') + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "cols": "6",
      "xl": "3"
    }
  }, [(_vm.rtpType === 'group') ? _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "minValue": 2,
      "maxValue": 10,
      "inputLabel": 'Nombre de débiteurs',
      "placeholderValue": 'Nombre de débiteurs'
    },
    model: {
      value: (_vm.nbDebtors),
      callback: function($$v) {
        _vm.nbDebtors = $$v
      },
      expression: "nbDebtors"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "cols": "6",
      "xl": "3"
    }
  }, [(_vm.rtpType === 'group') ? _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "minValue": 0,
      "inputLabel": _vm.$t('common.amnt_ttl'),
      "placeholderValue": _vm.$t('common.amnt_ttl'),
      "warningIndicator": _vm.amountTotalSaved !== '0' && _vm.amountTotal !== _vm.amountTotalSaved,
      "specificMessage": _vm.$t('errors.amnt_ttl_chngd'),
      "typingDone": _vm.changeDebtorsAmount
    },
    model: {
      value: (_vm.amountTotal),
      callback: function($$v) {
        _vm.amountTotal = $$v
      },
      expression: "amountTotal"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.rtpType === 'group') ? _c('b-row', {
    staticClass: "form-group justify-content-end"
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "font-size": "12px",
      "width": "100%"
    }
  }, [_c('font', {
    attrs: {
      "color": _vm.sumColor
    }
  }, [_vm._v("\n              " + _vm._s(_vm.amountTotalSaved === '' ? '0' + '€' : _vm.amountTotalSaved + '€') + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.of_label')))]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "#12bcf1"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.amountTotal === '' ? '0' + '€' : _vm.amountTotal + '€') + "\n            ")])], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "id": "recipient-list",
      "title": _vm.$t('creation_forms.dbtrs_info')
    }
  }, _vm._l((_vm.enteredDebtors), function(debtor, debtorIndex) {
    return _c('b-row', {
      key: debtor.debtorId,
      staticClass: "group-border"
    }, [(_vm.isSmartphoneOS && !_vm.isDebtorAnonymous(debtor)) ? _c('b-col', {
      staticClass: "text-center",
      staticStyle: {
        "padding": "0px"
      },
      attrs: {
        "cols": "2",
        "xl": "1",
        "align-self": "center"
      }
    }, [_c('div', [_c('a', {
      staticClass: "d-flex flex-column",
      on: {
        "click": function($event) {
          return _vm.scanQRCode(debtor.debtorId)
        }
      }
    }, [_c('f7-icon', {
      staticClass: "fa-4x",
      attrs: {
        "fa": "qrcode"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Scan")])], 1)])]) : _vm._e(), _vm._v(" "), _c('b-col', [_c('b-row', [(_vm.isDebtorAnonymous(debtor)) ? [_c('b-col', {
      staticClass: "text-center justify-content-between",
      attrs: {
        "cols": "5",
        "xl": "3",
        "align-self": "center"
      }
    }, [_c('b-row', [_c('b-col', {
      staticStyle: {
        "text-align": "left",
        "padding-right": "0px"
      },
      attrs: {
        "cols": "6",
        "align-self": "center"
      }
    }, [_c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('requestToPay.anon_debtor')) + "\n                      "), (_vm.enteredDebtors.length > 1) ? _c('span', [_vm._v("\n                        " + _vm._s((parseInt(debtor.debtorId) + 1).toString()) + "\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
      staticStyle: {
        "text-align": "left",
        "padding-left": "5px"
      },
      attrs: {
        "cols": "6",
        "align-self": "center"
      }
    }, [_c('f7-icon', {
      staticClass: "text-success",
      attrs: {
        "fa": "check"
      }
    })], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (!_vm.isDebtorAnonymous(debtor)) ? [_c('b-col', {
      staticClass: "form-group",
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "cols": "6",
        "xl": "3"
      }
    }, [_c('form-contact-dropdown-label-input', {
      attrs: {
        "isMandatory": "",
        "id": 'debtor-name-' + debtorIndex.toString(),
        "inputLabel": _vm.$t('common.nme'),
        "placeholderValue": _vm.$t('common.nme'),
        "mandatoryErrorIndicator": _vm.beneficiaireError
      },
      on: {
        "input": function($event) {
          debtor.debtorSelected = false
        },
        "change-iban": function($event) {
          debtor.debtorBank = $event
        },
        "change-identifier": function($event) {
          debtor.debtorEmail = $event
        },
        "change-contact": function($event) {
          return _vm.changeContact($event, debtor)
        }
      },
      model: {
        value: (debtor.debtorName),
        callback: function($$v) {
          _vm.$set(debtor, "debtorName", $$v)
        },
        expression: "debtor.debtorName"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "cols": "6",
        "xl": "3"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "isMandatory": "",
        "id": 'debtor-email-' + debtorIndex.toString(),
        "inputLabel": _vm.$t('common.idtfr'),
        "placeholderValue": _vm.$t('creation_forms.debtor_email_siren_small'),
        "disabled": debtor.debtorSelected
      },
      model: {
        value: (debtor.debtorEmail),
        callback: function($$v) {
          _vm.$set(debtor, "debtorEmail", $$v)
        },
        expression: "debtor.debtorEmail"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "cols": "6",
        "xl": "4"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "id": 'debtor-bank-' + debtorIndex.toString(),
        "isMandatory": !_vm.ibanModifAccepted,
        "inputLabel": _vm.$t('bank_accounts.bank_account_singular'),
        "placeholderValue": _vm.$t('common.ibn'),
        "disabled": debtor.debtorSelected
      },
      model: {
        value: (debtor.debtorBank),
        callback: function($$v) {
          _vm.$set(debtor, "debtorBank", $$v)
        },
        expression: "debtor.debtorBank"
      }
    })], 1)] : _vm._e(), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      staticStyle: {
        "margin-bottom": "0rem"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "id": 'debtor-amount-' + debtorIndex.toString(),
        "isMandatory": !_vm.amountModifAccepted,
        "inputType": 'number',
        "inputLabel": _vm.$t('common.amnt'),
        "placeholderValue": _vm.$t('common.amnt'),
        "typingDone": _vm.changeAmountTotal,
        "disabled": _vm.enteredDebtors.length > 1 && parseInt(debtor.debtorId) === _vm.enteredDebtors.length - 1
      },
      model: {
        value: (debtor.amount),
        callback: function($$v) {
          _vm.$set(debtor, "amount", $$v)
        },
        expression: "debtor.amount"
      }
    })], 1), _vm._v(" "), (_vm.isDebtorAnonymous(debtor)) ? _c('b-col', {
      staticClass: "form-group",
      staticStyle: {
        "margin-bottom": "0rem"
      },
      attrs: {
        "cols": "2"
      }
    }, [_c('span', {
      staticClass: "col-1 fa fa-times-circle text-danger",
      staticStyle: {
        "font-size": "25px",
        "margin-top": "30px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.cancelDebtor(debtor)
        }
      }
    })]) : _vm._e()], 2), _vm._v(" "), _c('b-row', [(_vm.debugQRCode && debtor.debtorToken !== '') ? [_c('b-col', {
      staticStyle: {
        "font-size": "9px",
        "color": "#b8b8b8"
      },
      attrs: {
        "cols": "6"
      }
    }, [_c('b', [_vm._v("Token: ")]), _vm._v(" " + _vm._s(debtor.debtorToken) + "\n              ")])] : _vm._e()], 2)], 1)], 1)
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "id": "rtp-settings",
      "title": _vm.$t('common.formsSubTitle.rqst_to_pay_sttngs')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.ibanModifAccepted),
      callback: function($$v) {
        _vm.ibanModifAccepted = $$v
      },
      expression: "ibanModifAccepted"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('requestToPay.bankAccountModif')) + "\n          ")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.amountModifAccepted),
      callback: function($$v) {
        _vm.amountModifAccepted = $$v
      },
      expression: "amountModifAccepted"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('creation_forms.dbtr_may_ngtt_amnt')) + "\n          ")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.dateModifAccepted),
      callback: function($$v) {
        _vm.dateModifAccepted = $$v
      },
      expression: "dateModifAccepted"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('creation_forms.dbtr_may_chng_date')) + "\n          ")]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.installmentsAccepted),
      callback: function($$v) {
        _vm.installmentsAccepted = $$v
      },
      expression: "installmentsAccepted"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('creation_forms.allowMultipleInst')) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "settings-delay",
      "sm": "6"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.acceptance')) + ": "), _c('br'), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "settings-delay-accept"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "name": "acceptance-radio",
      "value": "now"
    },
    model: {
      value: (_vm.doesAcceptNow),
      callback: function($$v) {
        _vm.doesAcceptNow = $$v
      },
      expression: "doesAcceptNow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.accept_now')) + "\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptExpirationTime),
      expression: "acceptExpirationTime"
    }],
    staticClass: "miniFormControl",
    attrs: {
      "disabled": _vm.doesAcceptNow !== 'now',
      "type": "text",
      "id": "settings-delay-accept-time"
    },
    domProps: {
      "value": (_vm.acceptExpirationTime)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.acceptExpirationTime = $event.target.value
      }, function($event) {
        _vm.acceptExpirationTime = isNaN(parseInt(_vm.acceptExpirationTime)) ? 1 :
          (parseInt(_vm.acceptExpirationTime) <= 0 ? 1 : parseInt(_vm.acceptExpirationTime))
      }]
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.after_sent')) + "\n            ")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "name": "acceptance-radio",
      "value": "later"
    },
    model: {
      value: (_vm.doesAcceptNow),
      callback: function($$v) {
        _vm.doesAcceptNow = $$v
      },
      expression: "doesAcceptNow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.accept_later')) + "\n            ")])], 1), _vm._v(" "), _vm._v("\n          " + _vm._s(_vm.$t('requestToPay.payment')) + ": "), _c('br'), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "settings-delay-pay"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "name": "payment-radio",
      "value": "none"
    },
    on: {
      "change": function($event) {
        _vm.isSCTInst = false
      }
    },
    model: {
      value: (_vm.doesPayNow),
      callback: function($$v) {
        _vm.doesPayNow = $$v
      },
      expression: "doesPayNow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.no_mr_payment')) + "\n            ")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "name": "payment-radio",
      "value": "now"
    },
    model: {
      value: (_vm.doesPayNow),
      callback: function($$v) {
        _vm.doesPayNow = $$v
      },
      expression: "doesPayNow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.aftr_accpt')) + "\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payExpirationTime),
      expression: "payExpirationTime"
    }],
    staticClass: "miniFormControl",
    attrs: {
      "disabled": _vm.doesPayNow !== 'now',
      "type": "text",
      "id": "settings-delay-pay-time"
    },
    domProps: {
      "value": (_vm.payExpirationTime)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.payExpirationTime = $event.target.value
      }, function($event) {
        _vm.payExpirationTime = isNaN(parseInt(_vm.payExpirationTime)) ? 1 :
          (parseInt(_vm.payExpirationTime) <= 0 ? 1 : parseInt(_vm.payExpirationTime))
      }]
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.after_hours')) + "\n            ")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "name": "payment-radio",
      "value": "later"
    },
    on: {
      "change": function($event) {
        _vm.isSCTInst = false
      }
    },
    model: {
      value: (_vm.doesPayNow),
      callback: function($$v) {
        _vm.doesPayNow = $$v
      },
      expression: "doesPayNow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.payment_later')) + "\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start"
  }, [_c('b-col', {
    staticClass: "p-0",
    attrs: {
      "cols": "6",
      "md": "3",
      "offset": "6",
      "offset-md": "8"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.sendPayments
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "paper-plane"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-xl-inline"
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.snd_req')))]), _vm._v(" "), _c('span', {
    staticClass: "d-xl-none"
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.snd')))])], 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15e00520", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15e00520","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/PRCreateTemplate.vue
// module id = 2342
// module chunks = 2